// extracted by mini-css-extract-plugin
module.exports = {"ActionsHolder":"StorePageActionMenu_ActionsHolder__3F2Fh"};